export const it = {
    'buttons': {
        'return': 'Ritorna'
    },
    'selects': {
        'currency': {
            'label': 'Valuta',
            'placeholder': 'Scegli una valuta',
            'options-title': 'Elenco delle valute disponibili'
        },
        'currency-and-network': {
            'placeholder': 'Scegli una valuta e una rete',
            'options-title': 'Elenco delle valute disponibili'
        },
        'selected-label': 'Selezionato: {selected} di {length}',
        'search': 'Cerca',
        'errors': {
            'invalid': 'Valore non valido',
            'required': 'Richiesto',
            'card-holder': 'Inserisci nome e cognome del titolare della carta',
            'input-amount': 'Inserisci l’importo',
            'fill-card': 'Compila le informazioni della carta'
        },
        'empty-list': 'Elenco vuoto',
        'address': {
            'label': 'Indirizzo di prelievo in {currency}',
            'options-title': 'Elenco degli indirizzi disponibili'
        },
        'cardholder-input': {
            'placeholder': 'Titolare della carta'
        }
    },
    'text-fields': {
        'labels': {
            'personal': {
                'address': 'Il tuo indirizzo per il deposito'
            },
            'invoice': {
                'address': 'Indirizzo',
                'paid-amount': 'Importo pagato'
            }
        }
    },
    'labels': {
        'deposit': 'Deposito',
        'withdraw': 'Prelievo',
        'currency': 'Valuta',
        'amount': 'Importo',
        'invoice': {
            'remaining-time': 'Tempo rimanente per il pagamento',
            'status': {
                'expires': 'Tempo scaduto',
                'success': 'Pagamento riuscito',
                'error': 'Errore'
            },
            'partially-paid': {
                'title': 'Parzialmente pagato',
                'info': 'L’importo è stato parzialmente pagato. L’importo rimanente deve essere pagato per completare il pagamento.'
            },
            'orphan': {
                'title': 'Transazione orfana',
                'description': 'Una delle transazioni in questo ordine contiene una rete o una valuta errata.',
                'contact': 'Contatta il supporto tecnico con ID:'
            },
            'you-paid': 'Hai pagato',
            'active-order': 'Ordine attivo',
            'new-invoice': 'Nuova fattura',
            'order-id': 'ID fattura',
            'payment-amount': 'Importo del pagamento'
        },
        'continue': 'Continua',
        'payout': {
            'address': 'Indirizzo di prelievo in {currency}',
            'tag-or-memo': 'TAG o MEMO',
            'status': {
                'processed': 'Completato',
                'error': 'Errore',
                'orphan': 'Transazione orfana',
                'approve_rejected': 'Rifiutato',
                'in-progress': 'In corso',
                'need-approve': 'Richiede approvazione',
                'awaiting-confirmation': 'La tua richiesta di prelievo è in attesa di conferma'
            },
            'info': {
                'withdraw-id': 'ID prelievo',
                'tx-hash': 'TX hash',
                'currency-and-network': 'Valuta e rete',
                'address': 'Indirizzo',
                'tag-or-memo': 'TAG o MEMO',
                'amount': 'Importo da prelevare'
            }
        },
        'fiat': {
            'title': 'Deposito tramite fiat',
            'info': {
                'amount': 'Importo',
                'date': 'Data del pagamento',
                'id': 'ID deposito',
                'system': 'Sistema di pagamento'
            },
            'status': {
                'new': 'Nuovo',
                'pending': 'In sospeso',
                'authorized': 'Autorizzato',
                'confirmed': 'Confermato',
                'reconciled': 'Riconciliato',
                'error': 'Errore',
                'declined': 'Rifiutato'
            }
        }
    },
    'errors': {
        'wrong-widget-id': 'ID widget errato',
        'wrong-ext-user-id': 'ID utente esterno errato',
        '404': 'Oops! Abbiamo cercato ma non abbiamo trovato ciò che stai cercando.',
        'without-xt-user-id-withdrawal': 'Prelievo non disponibile. Il parametro extUserId non è stato trasmesso',
        'without-xt-user-id-deposit': 'Deposito non disponibile. Il parametro extUserId non è stato trasmesso'
    },
    'invoice': {
        'order': 'Ordine',
        'inputs': {
            'email': {
                'label': 'Indirizzo e-mail',
                'placeholder': 'Inserisci il tuo indirizzo e-mail'
            },
            'amount': {
                'label': 'Importo',
                'placeholder': 'Inserisci l’importo'
            }
        },
        'text-fields': {
            'expanded': {
                'in-usd': 'Importo in',
                'rate': 'Tasso di cambio',
                'payment-id': 'ID pagamento',
                'description': 'Descrizione'
            }
        },
        'order-public-link': {
            'do-not-refresh': 'Non aggiornare la pagina o aprire la fattura in una',
            'new-tab': 'nuova scheda'
        },
        'statuses': {
            'ERROR': 'ERRORE',
            'PENDING': 'IN SOSPESO',
            'PROCESSED': 'ELABORATO',
            'REJECTED': 'RIFIUTATO',
            'OVERPAID': 'SOVRAPAGATO',
            'CREATED': 'CREATO',
            'PARTIAL': 'PARZIALMENTE PAGATO',
            'INIT': 'INIZIATO',
            'EXPIRED': 'SCADUTO'
        }
    },
    'personal': {
        'titles': {
            'deposit': 'Deposito',
            'payment-history': 'Storico dei pagamenti'
        },
        'payment-history': {
            'empty-label': 'Tutte le tue transazioni inviate all’indirizzo indicato saranno disponibili qui',
            'headers': {
                'date': 'Data e ora',
                'amount': 'Importo',
                'tx': 'Tx_hash',
                'status': 'Stato'
            },
            'statuses': {
                'processed': 'Elaborato',
                'pending': 'In sospeso',
                'rejected': 'Rifiutato',
                'error': 'Errore'
            },
            'in': 'in'
        },
        'qr-block': {
            'empty-label': 'Ricarica con criptovaluta',
            'qr-info-pre-invoice': 'Invia solo',
            'qr-info-pre-personal': 'Invia qualsiasi importo solo a',
            'qr-info-post': 'a questo indirizzo',
            'qr-info-minimal': 'I trasferimenti inferiori a 1 USD non sono accreditati'
        }
    },
    'fiat': {
        'titles': {
            'deposit': 'Deposito tramite fiat',
            'payment-history': 'Storico dei pagamenti'
        },
        'labels': {
            'pay': 'Paga',
            'service-commission': 'Importo della commissione di servizio',
            'total': 'Totale',
            'you-pay': 'Paghi'
        }
    },
    'popup': {
        'orphan-danger': {
            'title': 'Transazione orfana',
            'info': 'Una delle transazioni in questo ordine contiene una rete o una valuta errata.',
            'support': 'Contatta il supporto tecnico con ID'
        }
    },
    'cookie-policy': {
        'by-clicking': 'Cliccando sul pulsante "Continua", accetti automaticamente',
        'our': 'la nostra politica sui cookie'
    },
    'payout': {
        'payout': 'Pagamento',
        'output': 'Prelievo',
        'withdraw': 'Prelievo',
        'errors': {
            'wrong-address': 'L’indirizzo non appartiene alla rete {network}'
        }
    }
}
